import { MouseEventHandler } from 'react'
import { LogOut } from '@stratascratch/icons'
import Button from '../Button'
import UserMenu, { Props as UserMenuProps } from './UserMenu'

type Props = {
  handleLogout: () => void
} & UserMenuProps

function LoggedInAuthMenu({ handleLogout, renderLink, closeMenu }: Props) {
  const logout: MouseEventHandler = () => {
    handleLogout()
    closeMenu()
  }

  return (
    <>
      <UserMenu renderLink={renderLink} closeMenu={closeMenu} />
      <Button
        as="button"
        onClick={logout}
        variant="secondary"
        size="circle"
        aria-label="Logout"
      >
        <LogOut />
      </Button>
    </>
  )
}

export default LoggedInAuthMenu
